import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const workflowSchemeConfigEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-project-settings-workflow-scheme-config", jiraSpaEntry: "async-project-settings-workflow-scheme-config" */ './src'
			),
	),
	getPreloadProps: () => ({}),
});
